import React,{useState, useEffect} from 'react';
import axios from 'axios';
import { makeStyles, darken } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import Paper from '@material-ui/core/Paper';

import './App.css';
import Checkout from './Checkout';
import { apiBase, payHash } from './api';
import { loadTranzila } from './tranzila';
import { pageLanguage, direction } from './lang';
import { DispatchContext,useChangeTheme } from './components/ThemeContext';


//import { loadCSS } from 'fg-loadcss/src/loadCSS';




//import { ThemeProvider } from './components/ThemeContext';
/*
import Avatar from '@material-ui/core/Avatar';

import { StylesProvider, jssPreset } from '@material-ui/styles';

import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import Brightness7Icon from '@material-ui/icons/Brightness7';
import Tooltip from '@material-ui/core/Tooltip';
import FormatTextdirectionLToR from '@material-ui/icons/FormatTextdirectionLToR';
import FormatTextdirectionRToL from '@material-ui/icons/FormatTextdirectionRToL';
import IconButton from '@material-ui/core/IconButton';


import { withStyles, useTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';

*/

//import { useChangeTheme } from './components/ThemeContext';


//const LinFrame = React.lazy(() => import('./components/LinFrame'));




/*
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    //backgroundColor: theme.palette.background.level1,
    backgroundColor: theme.palette.background.default
    //backgroundColor: 'red',
  },
})
)
*/
let dependenciesLoaded = false


const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },


    appBar: {
      //position: 'relative',
      height: "236px",

      //small height: "173px"
      zIndex: -1,
      position: 'absolute',
      top: 0,
      width: "100%",
      // A6: was a hand-rolled LightenDarkenColor that subtracted from each channel without
      // clamping and toString(16)'d the result. A primary colour with any channel under 10
      // (or the 0x00 that a dark brand colour has) borrowed from the next channel and
      // produced a five-digit string, so the gradient rendered as garbage or not at all.
      // MUI's darken() clamps, and was already imported in ThemeContext for this.
      background: "linear-gradient(0deg, " + darken(theme.palette.primary.main, 0.1) + " , " + theme.palette.primary.main + ")"
    },

    appLogo:{
      textAlign: "center",
      paddingTop: "24px",
      paddingBottom: "15px",
      zIndex: 0
    },



}));



function loadDependencies() {
  if (dependenciesLoaded) {
    return;
  }

  dependenciesLoaded = true;

  /*loadCSS(
    'https://fonts.googleapis.com/icon?family=Material+Icons',
    document.querySelector('#material-icon-font'),
  );*/

}

/**
 * The states in which a link cannot take money, and what each says.
 *
 * Distinct messages on purpose: "expired" and "retired" send a payer to the merchant for a
 * new link, while "already paid" tells them to do nothing. One combined message would have
 * somebody chasing a business about a payment they already made.
 */
const CLOSED_STATES = {
  expired: 'LinkExpired',
  closed: 'LinkClosed',
  paid: 'AlreadyPaid',
};

function AppWrapper(props) {
  const { children, } = props;

  React.useEffect(() => {
    loadDependencies();
    //registerServiceWorker();
  }, []);

  return (<React.Fragment>{children}</React.Fragment>);
}

function App() {


    const changeTheme = useChangeTheme();
    const dispatch = React.useContext(DispatchContext);

    const { t, i18n } = useTranslation();



  const [data, setData] = useState(false);
  // A1: a load that failed and a load still in flight used to look identical -- "Loading
  // Data..." forever, with the real reason in a console nobody has open.
  const [loadError, setLoadError] = useState(false);
  const [attempt, setAttempt] = useState(0);

  const hash = payHash();

  useEffect(() => {
    // NOT an async effect function. `useEffect(async () => …)` returns a promise, which React
    // takes for a cleanup function; it warns, and any cleanup this effect ever grows would be
    // silently dropped.
    let cancelled = false;

    if (!hash) {
      setLoadError(true);
      return undefined;
    }

    const load = async () => {
      try {
        // noiframe=1: this page mints its own gateway session when the payer reaches the
        // payment step, so loading the link must not mint one. See
        // PaymentreqController::loadMintsSession.
        const result = await axios(apiBase() + '/paymentreq/load/' + hash + '?noiframe=1');

        if (cancelled) return;

        setData(result.data);
        setLoadError(false);

        // the document's language, or for an item link the payer's browser (src/lang.js)
        const lang = pageLanguage(result.data, window.navigator);
        changeTheme({ direction: direction(lang) });
        document.documentElement.lang = lang === 'he_il' ? 'he' : 'en';
        i18n.changeLanguage(lang);

        // Only now do we know which gateway this row uses, which is the point: a ZCredit or
        // Pelecard tenant's page loads no third-party script at all. See src/tranzila.js.
        loadTranzila(result.data.credit_type);

        if (result.data.primary_color && result.data.secondary_color) {
          dispatch({
            type: 'CHANGE',
            payload: {
              paletteColors: {
                primary: { main: result.data.primary_color },
                secondary: { main: result.data.secondary_color },
              },
            },
          });
        }
      } catch (e) {
        if (!cancelled) setLoadError(true);
      }
    };

    load();

    return () => { cancelled = true; };
  },[hash, attempt, changeTheme, dispatch, i18n]);


  /*
  const theme = useTheme();

  const changeTheme = useChangeTheme();
  const handleTogglePaletteType = () => {
    const paletteType = theme.palette.type === 'light' ? 'dark' : 'light';

    changeTheme({ paletteType });
  };
  const handleToggleDirection = () => {
    changeTheme({ direction: theme.direction === 'ltr' ? 'rtl' : 'ltr' });
  };
  const classes=useStyles()
  const { loading } = useAuth0();
  if (loading) {
    return <div>Loading </div>;
  }
  */

  const classes = useStyles();
  return (
    <AppWrapper>
      <div className={classes.appBar} />
      <div  className={classes.appLogo}>
        <img src="/logo.png" alt={"Linet Pay"} />
      </div>
      {loadError && (
        <Paper className={classes.paper}>
          <Typography variant="h6" gutterBottom>{t('PageUnavailable')}</Typography>
          <Typography variant="body1" gutterBottom>{t('PageUnavailableDetail')}</Typography>
          {/* Only offer a retry for something a retry can fix. A path that is not a payment
              link will not become one. */}
          {hash && (
            <Button variant="contained" color="primary" onClick={() => setAttempt(a => a + 1)}>
              {t('Retry')}
            </Button>
          )}
        </Paper>
      )}
      {!loadError && !data && <Paper className={classes.paper}>{t('LoadingData')}</Paper>}
      {!loadError && data && !data.jsond_doc && (
        <Paper className={classes.paper}>
          <Typography variant="h6">{t('PageUnavailable')}</Typography>
        </Paper>
      )}
      {/* `state` is computed server-side for an item link (PaymentRequest::payState) and
          absent for a document request, whose own `jsond_doc.paid` branch below still
          answers -- so a row minted before any of this still renders. */}
      {!loadError && data && data.jsond_doc && CLOSED_STATES[data.state] && (
        <Paper className={classes.paper}>
          <Typography variant="h6">{t(CLOSED_STATES[data.state])}</Typography>
        </Paper>
      )}

      {!loadError && data && data.jsond_doc && !CLOSED_STATES[data.state] && data.jsond_doc.paid && (
        <Paper className={classes.paper}>
          <Typography variant="h6">{t('AlreadyPaid')}</Typography>
        </Paper>
      )}

      {!loadError && data && data.jsond_doc && !CLOSED_STATES[data.state] && !data.jsond_doc.paid && <Checkout data={data} />}
    </AppWrapper>
  );
}
export default App
